import { Box, CircularProgress, RadioGroup } from "@mui/material";
import { IMarketplace } from "../../../../interfaces/IMarketplace";
import { RadioCard } from "../../../../../core/components/RadioCard";
import { TipoAutenticacaoCardapio, TipoAutenticacaoCardapioDescricao, TipoAutenticacaoCardapioTitulo } from "../../../../enum/TipoAutenticacaoCardapio";
import { useState } from "react";
import { useMarketplaces } from "../../../../hooks/useMarketplaces";

interface TipoAutenticacaoCardapioContainerProps {
    marketplace: IMarketplace;
    refresh: () => void;
}

export const TipoAutenticacaoCardapioContainer = ({ marketplace, refresh }: TipoAutenticacaoCardapioContainerProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const { salvar } = useMarketplaces();

    const tipoAtual = marketplace?.configuracao?.tipoAutenticacaoCardapio ?? TipoAutenticacaoCardapio.VERIFICADA;

    const handleTipoAutenticacao = async (tipo: TipoAutenticacaoCardapio) => {
        setLoading(true);
        await salvar({
            ...marketplace,
            configuracao: {
                ...marketplace.configuracao,
                tipoAutenticacaoCardapio: tipo
            }
        });
        setTimeout(() => {
            refresh();
            setLoading(false);
        }, 1500);
    }

    if (loading) {
        return (
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: '5rem',
                marginBottom: '5rem',
            }}>
                <CircularProgress size={50} />
            </Box>
        );
    }

    return (
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%", gap: 0 }}>
            <RadioGroup
                name="tipo-autenticacao-cardapio"
                row
                sx={{ display: "flex", justifyContent: "flex-start", gap: '2rem', width: "100%" }}
                onChange={(e) => handleTipoAutenticacao(e.target?.value as TipoAutenticacaoCardapio)}
            >
                <RadioCard
                    labelTitle={TipoAutenticacaoCardapioTitulo.SIMPLES}
                    labelDescription={TipoAutenticacaoCardapioDescricao.SIMPLES}
                    labelValue={TipoAutenticacaoCardapio.SIMPLES}
                    key={TipoAutenticacaoCardapio.SIMPLES}
                    selected={tipoAtual == TipoAutenticacaoCardapio.SIMPLES}
                    onClick={() => handleTipoAutenticacao(TipoAutenticacaoCardapio.SIMPLES)}
                />
                <RadioCard
                    labelTitle={TipoAutenticacaoCardapioTitulo.VERIFICADA}
                    labelDescription={TipoAutenticacaoCardapioDescricao.VERIFICADA}
                    labelValue={TipoAutenticacaoCardapio.VERIFICADA}
                    key={TipoAutenticacaoCardapio.VERIFICADA}
                    selected={tipoAtual == TipoAutenticacaoCardapio.VERIFICADA}
                    onClick={() => handleTipoAutenticacao(TipoAutenticacaoCardapio.VERIFICADA)}
                />
            </RadioGroup>
        </Box>
    );
}
